export default __webpack_public_path__ + "static/media/plusIconOrange.fd8dac1b.svg";